function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import AllowedValuesEditing from './components/AllowedValuesEditing';
var LOW_PRIORITY = 500;

var InputOutputValues = function InputOutputValues(components) {
  _classCallCheck(this, InputOutputValues);

  components.onGetComponent('context-menu', LOW_PRIORITY, function () {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (context.contextMenuType && context.contextMenuType === 'type-ref-edit') {
      return AllowedValuesEditing;
    }
  });
};

export { InputOutputValues as default };
InputOutputValues.$inject = ['components'];
//# sourceMappingURL=AllowedValuesEditingProvider.js.map